import { Directive, EventEmitter, Input, Output } from "@angular/core";
import { UntypedFormControl, NG_VALIDATORS, Validator } from "@angular/forms";

@Directive({
  selector: '[appValidateInput][ngModel]',
  providers: [{
    provide: NG_VALIDATORS,
    useExisting: ValidatedInputValidatorDirective,
    multi: true
  }]
})
export class ValidatedInputValidatorDirective implements Validator {
  @Input() appValidateInput = true;
  // validation options
  @Input() preventNanValues: boolean;
  @Input() preventNegativeValues: boolean;
  @Input() validationID: '';

  @Output() errorMessageUpdate = new EventEmitter<{ message: String, params: any }>();
  @Output() validationUpdated = new EventEmitter();

  private form: UntypedFormControl;
  errorMessage: String;
  errorParams: any;
  isSanityError: boolean;

  @Input() set setErrorMessage(message: string) {
    this.errorMessage = message;
    if (this.form != null) {
      if (this.validate(this.form)) {
        setTimeout(() => this.form.setErrors({ 'incorrect': true }));
      } else {
        this.form.setErrors(null);
      }
    }
  }

  validate(form: UntypedFormControl) {
    this.form = form;
    let isValid = true;
    if (form.value || form.value === 0) { // input is not empty
      if (this.preventNanValues && isNaN(form.value.toString().replace(/[,]/g, ''))) {
        isValid = false;
        this.errorMessage = 'HELPER.UNIT_VALUE.ERRORS.MUST_BE_NUMERIC';
      } else if (this.errorMessage === 'HELPER.UNIT_VALUE.ERRORS.MUST_BE_NUMERIC') {
        this.errorMessage = '';
      }
      if (this.preventNegativeValues) {
        if (Number(form.value.replace(',', '')) < 0 ||
          (form.value.startsWith('-') && !form.value.startsWith('-0'))) {
          isValid = false;
          this.errorMessage = 'HELPER.UNIT_VALUE.ERRORS.MUST_NOT_BE_NEGATIVE';
        } else if (this.errorMessage === 'HELPER.UNIT_VALUE.ERRORS.MUST_NOT_BE_NEGATIVE') {
          this.errorMessage = '';
        }
      }
    } else { // input is empty
      this.errorMessage = '';
    }

    if (this.errorMessage) {
      isValid = false;
    }

    this.errorMessageUpdate.emit({ message: this.errorMessage, params: this.errorParams });
    this.validationUpdated.emit(true);
    return (isValid) ? null : { invalid: true };
  }
}
